/**
 * Where the product introduction is served.
 *
 * The page itself is `docs/marketing/arkhe-holdem-intro-ko.html` — the
 * one copy, edited where the rest of the documentation lives. The
 * build emits it at this path (`vite-plugins/intro-page.ts`), so the
 * lobby links here and the server serves it like any other file in
 * the bundle.
 */
export const INTRO_PAGE_URL = "/intro.html";
